import React from 'react';
import { Layout, Button, Typography, Space, Avatar } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { useLogout } from '../../hooks/useLogout';

import logo from '../../assets/primary_logo.webp';

const { Header } = Layout;
const { Text } = Typography;

const NewAppHeader = () => {
    const { user, isAuthenticated } = useAuth0();
    const { logout } = useLogout();

    if (!isAuthenticated) return null;

    return (
        <Header style={{
            background: '#fff',
            padding: '0 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            height: '64px'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={logo} alt="FuturX Logo" style={{ height: '32px' }} />
            </div>

            <Space size="middle">
                <Space>
                    <Avatar src={user?.picture} icon={<UserOutlined />} style={{ backgroundColor: '#f56a00' }} />
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }} className="hide-on-mobile">
                        <Text strong style={{ fontSize: 13 }}>{user?.name}</Text>
                        <Text type="secondary" style={{ fontSize: 11 }}>{user?.email}</Text>
                    </div>
                </Space>
                <Button
                    type="text"
                    icon={<LogoutOutlined />}
                    onClick={() => logout()}
                    style={{ color: '#ff4d4f' }}
                >
                    <span className="hide-on-mobile">Logout</span>
                </Button>
            </Space>
        </Header>
    );
}

export default NewAppHeader;